import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import CpapWrapper from "@components/layouts/cpapWrapper";

export default function CarInjuryJusticeHome(): ReactElement {
    return (
        <CpapWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#2380C3" />
                </div>
                <FormSection iconsFillColor="#2380C3" />
            </div>
        </CpapWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
